// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AccountAttestationAttributeModel {
    static getAttributeTypeMap() {
        return AccountAttestationAttributeModel.attributeTypeMap;
    }
}
AccountAttestationAttributeModel.discriminator = undefined;
AccountAttestationAttributeModel.additionalProperties = false;
AccountAttestationAttributeModel.attributeTypeMap = [
    {
        "name": "attestationAttributeId",
        "baseName": "attestationAttributeId",
        "type": "number"
    },
    {
        "name": "attestationSourceDesc",
        "baseName": "attestationSourceDesc",
        "type": "string"
    },
    {
        "name": "value",
        "baseName": "value",
        "type": "string"
    },
    {
        "name": "attestationStartDate",
        "baseName": "attestationStartDate",
        "type": "Date"
    },
    {
        "name": "attestationEndDate",
        "baseName": "attestationEndDate",
        "type": "Date"
    },
    {
        "name": "documentId",
        "baseName": "documentId",
        "type": "number"
    },
    {
        "name": "attestationSourceCode",
        "baseName": "attestationSourceCode",
        "type": "string"
    },
];
//# sourceMappingURL=accountAttestationAttributeModel.js.map